import React from "react";
import { Box } from "@draftkings/arena-web";
export const OpenMarkIcon = React.memo(function BetsChunk({ variant, accessibilityText }) {
    return React.createElement(Box, { variant: `icon.${variant}`, "aria-label": accessibilityText });
});
//# sourceMappingURL=OpenMarkIcon.js.map